import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useDashboard } from "context/dashboard";
import useAuth from "context/auth";

import { ReactComponent as OrganizationsIcon } from 'assets/icons/ico_organizations.svg';
import { ReactComponent as OrganizationsAddIcon } from 'assets/icons/ico_organizations_add.svg';
import { ReactComponent as UserIcon } from 'assets/icons/ico_user.svg';
import { ReactComponent as NotificationsIcon } from 'assets/icons/ico_notifications.svg';
import { ReactComponent as AirParkSmallIcon } from 'assets/icons/ico_airpark_p_green.svg';

import Logo from "components/common/logo";
import ButtonText from "components/common/buttonText";
import OrganizationDesktopMenu from "../organizationDesktopMenu";

const DesktopMenu = () => {

    const { organization, organizations, user, showNotificationsMenu, setShowNotificationsMenu, notifications } = useDashboard();
    const { logout } = useAuth();
    const navigate = useNavigate();
    const [showOrganizationMenu, setShowOrganizationMenu] = useState();
    const [showUserMenu, setShowUserMenu] = useState();
    const { t } = useTranslation();
    const [showOrganizationMenuClassName, setShowOrganizationMenuClassName] = useState('flex text-left flex-col absolute right-8 top-8 p-6 min-w-[348px] rounded-3xl bg-white shadow z-30 transition-all ease-in-out duration-100 scale-75 opacity-50');
    const [showUserMenuClassName, setShowUserMenuClassName] = useState('flex text-left flex-col absolute right-8 top-8 p-6 min-w-[348px] rounded-3xl bg-white shadow z-30 transition-all ease-in-out duration-100 scale-75 opacity-50');

    const toggleOrganizationMenu = (e) => {
        e.preventDefault();
        setShowUserMenu(false);
        setShowOrganizationMenu(!showOrganizationMenu);
    }

    const toggleUserMenu = (e) => {
        e.preventDefault();
        setShowOrganizationMenu(false);
        setShowUserMenu(!showUserMenu);
    }

    const toggleNotificationMenu = (e) => {
        e.preventDefault();
        setShowNotificationsMenu(!showNotificationsMenu);
    }

    const navigateToOrganization = ((e, organizationExtId) => {
        e.preventDefault();
        setShowOrganizationMenu(false);
        navigate(`/${organizationExtId.toLowerCase()}`);
    });

    const handleLogoClick = (e) => {
        e.preventDefault();
        if (organization) {
            navigate(`/${organization.organizationExtId.toLowerCase()}`)
        }
    }

    const handleAddOrganization = () => {
        navigate('/verified/create-organization');
    };

    useEffect(() => {
        if (showOrganizationMenu) {
            setShowOrganizationMenuClassName('flex text-left flex-col absolute right-8 top-8 p-6 min-w-[348px] rounded-3xl bg-white shadow z-30 transition-all ease-in-out duration-100 scale-100 opacity-100');
        } else {
            setShowOrganizationMenuClassName('flex text-left flex-col absolute right-8 top-8 p-6 min-w-[348px] rounded-3xl bg-white shadow z-30 transition-all ease-in-out duration-100 scale-75 opacity-50');
        }
    }, [showOrganizationMenu]);

    useEffect(() => {
        if (showUserMenu) {
            setShowUserMenuClassName('flex text-left flex-col absolute right-0 top-8 p-6 min-w-[348px] rounded-3xl bg-white shadow z-30 transition-all ease-in-out duration-100 scale-100 opacity-100');
        } else {
            setShowUserMenuClassName('flex text-left flex-col absolute right-0 top-8 p-6 min-w-[348px] rounded-3xl bg-white shadow z-30 transition-all ease-in-out duration-100 scale-75 opacity-50');
        }
    }, [showUserMenu]);

    return (
        <>
            {/* Overlay */}
            {(showOrganizationMenu || showUserMenu) &&
                <div onClick={(e) => { e.preventDefault(); setShowOrganizationMenu(false); setShowUserMenu(false); }} className="fixed inset-0 z-20" />
            }

            <nav className="lg:flex hidden bg-white shadow h-16 items-center justify-between pr-6 pl-6 mb-6">
                <a title="Home" alt="Home" onClick={(e) => { handleLogoClick(e) }} href="#">
                    <div className="md:block hidden">
                        <Logo />
                    </div>
                    <div className="md:hidden block">
                        <AirParkSmallIcon className="h-11 w-11" />
                    </div>
                </a>
                <div className="flex items-center relative">
                    <button onClick={(e) => { e.preventDefault(); toggleOrganizationMenu(e); }} className="flex items-center">
                        {organization &&
                            <span className="text-base font-medium truncate text-ellipsis max-w-xs">{organization.name}</span>
                        }
                        <OrganizationsIcon className="h-5 w-5 ml-4" />
                    </button>
                    {showOrganizationMenu &&
                        <div className={showOrganizationMenuClassName}>
                            <div className="flex items-center">
                                <OrganizationsAddIcon className="w-5 h-5 mr-2" />
                                <span className="font-medium text-base">{t('topBar.organizations')}</span>
                            </div>
                            <div className="flex flex-col">
                                {organizations && organizations.map((o, i) => {
                                    return (
                                        <a key={i} href="#" onClick={(e) => { navigateToOrganization(e, o.organizationExtId); }} className="flex items-center pointer-cursor">
                                            <div className="flex justify-center w-5 mr-2">
                                                {organization && organization.name == o.name &&
                                                    <div className="flex justify-center h-2 w-2 rounded bg-green-500" />
                                                }
                                            </div>
                                            <span className="truncate pt-1 max-w-[240px]">{o.name}</span>
                                        </a>)
                                })
                                }
                            </div>
                            <ButtonText onClick={() => { handleAddOrganization(); }} isSecondary={true} className="mt-4">
                                <span className="text-center w-full">{t('topBar.addOrganization')}</span>
                            </ButtonText>
                        </div>
                    }
                    {/* <button onClick={(e) => { toggleNotificationMenu(e); }}>
                        <div className="ml-4 relative">
                            <NotificationsIcon className="h-5 w-5" />
                            {notifications?.filter(n => n.read == false).length > 0 &&
                                <span className="h-5 w-5 bg-airpark-red rounded-full text-white text-xs flex items-center justify-center absolute -top-2.5 -left-2.5 shadow">
                                    {notifications?.filter(n => n.read == false).length}
                                </span>
                            }
                        </div>
                    </button> */}
                    <button onClick={(e) => { toggleUserMenu(e); }}>
                        <UserIcon className="h-5 w-5 ml-4" />
                    </button>
                    {showUserMenu &&
                        <div className={showUserMenuClassName}>
                            <div className="flex items-center">
                                <UserIcon className="w-5 h-5 mr-2" />
                                <span className="font-medium text-base">{user.firstName} {user.lastName}</span>
                            </div>
                            <ButtonText onClick={() => { logout(); }} isSecondary={false} className="mt-4">
                                <span className="text-center w-full">{t('topBar.logout')}</span>
                            </ButtonText>
                        </div>
                    }
                </div>
            </nav>
            
            <OrganizationDesktopMenu />
        </>
    );
};

export default DesktopMenu;